<template>
    <div v-if="item.Url !== ''" class="alliance-item">
        <a :href="item.Url">
            <div class="alliance-wrapper">
                <div class="alliance-item__content">
                    <img :src="item.Image" :alt="item.Title">
                </div>
            </div>
        </a>
    </div>
    <div v-else class="alliance-item">
            <div class="alliance-wrapper">
                <div class="alliance-item__content">
                    <img :src="item.Image" :alt="item.Title">
                </div>
            </div>
    </div>
</template>

<script>
import moment from 'moment';
import he from 'he';

export default {
        props: ['item'],

  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('MMM DD, YYYY');
      }
    },
    formatTopicArray(value) {
      return value.map(topic => {
        let lastSegment = topic.split('/').filter(Boolean).pop(); // Get last segment
        return lastSegment
            .replace(/([a-z])([A-Z])/g, '$1 $2') // Add spaces between camelCase
            .replace(/_/g, ' '); // Replace underscores with spaces
      }).join(', ');
    },
    decode(value) {
      return he.decode(value);
    }
        },
        methods: {
            getCategories(item) { 
                if(typeof(item.TopicsNames) !== 'undefined' && item.TopicsNames.length > 0 )
                {
                    return item.TopicsNames.join(', ');
                }
            },
            formatDate(From, To) {
                From = new Date(From);
                To = new Date(To);
                const FromDate = From.getDate()
                const FromMonth = From.toLocaleString('default', { month: 'short' })
                const FromYear = From.getFullYear()
                const ToDate = To.getDate()
                const ToMonth = To.toLocaleString('default', { month: 'short' })
                let dateString = `${FromMonth} ${FromDate}, ${FromYear}`;
                if (isNaN(To) || To.getFullYear() === 1) return dateString;
                if (ToMonth != FromMonth) {
                    dateString = `${FromMonth} ${FromDate} - ${ToMonth} ${ToDate}, ${FromYear}`;
                }
                else {
                    dateString = `${ FromMonth} ${FromDate} - ${ToDate}, ${FromYear } `;
                }
                return dateString;
            }
        }
}
</script>